interface ContructorParams {
	leftCardTitle?: string | null
	leftCardText?: string | null
	middleCardTitle?: string | null
	middleCardText?: string | null
	rightCardTitle?: string | null
	rightCardText?: string | null
	headerImage?: string | null
	wideImage?: string | null
	locale: string
}
export class B2BContent {
	public leftCardTitle?: string | null
	public leftCardText?: string | null
	public middleCardTitle?: string | null
	public middleCardText?: string | null
	public rightCardTitle?: string | null
	public rightCardText?: string | null
	public headerImage?: string | null
	public wideImage?: string | null
	public locale: string

	public constructor(content: ContructorParams) {
		this.leftCardTitle = content.leftCardTitle
		this.leftCardText = content.leftCardText
		this.middleCardTitle = content.middleCardTitle
		this.middleCardText = content.middleCardText
		this.rightCardTitle = content.rightCardTitle
		this.rightCardText = content.rightCardText
		this.headerImage = content.headerImage
		this.wideImage = content.wideImage
		this.locale = content.locale
	}
}
